module.exports = __webpack_public_path__ + "static/media/mappa-telefono.630ca27f.svg";